import { MetaData } from 'Components/MetaData/Metadata';
import { LandingPageLayout } from 'Layouts/LandingPageLayout';
import { HowItWorksSection } from 'Pages/LandingPage/LoopAppSection/sections/HowItWorksSection';
import { CTA } from 'Pages/LoopForBusiness/CTA';
import React from 'react';
import { IImageSlider, IJumbotronContents } from 'Types/Interface/ILandingPage';
import { useHowItWorksLocalization } from 'Utils/localizationHooks';
import { Benefits } from './Benefits';
import { Campaigns } from './Campaigns';
import { Jumbotron } from './Components/Jumbotron';
import FeedbackPage from 'Assets/Images/Feedback-page.png';
import phoneScan from 'Assets/Images/phoneScan.png';
import loopWithBrands from 'Assets/Images/loopWithBrands.png';
import loopWithBrandsBasic from 'Assets/Images/loopWithBrandsBasic.png';


export const ProcessOverview = () => {

	const {localization:howItWorksLocalization} = useHowItWorksLocalization();

	const content:IJumbotronContents[] = [{
		heading : howItWorksLocalization?.heroTitle,
		text: howItWorksLocalization?.heroSubTitle,
		subText: ''
	}];

	const steps:IImageSlider[] = [
		{
			id: 0,
			label: howItWorksLocalization?.firstStepTitle,
			text:howItWorksLocalization?.firstStepDescription,
			src: phoneScan,
			mobileSrc: phoneScan
		},
		{
			id: 1,
			label: howItWorksLocalization?.secondStepTitle,
			text:howItWorksLocalization?.secondStepDescription,
			src: FeedbackPage,
			mobileSrc: FeedbackPage
		},
		{
			id: 2,
			label: howItWorksLocalization?.thirdStepTitle,
			text:howItWorksLocalization?.thirdStepDescription,
			src: loopWithBrands,
			mobileSrc: loopWithBrands
		},
		{
			id: 3,
			label: howItWorksLocalization?.fourthStepTitle,
			text:howItWorksLocalization?.fourthStepDescription,
			src: loopWithBrandsBasic,
			mobileSrc: loopWithBrandsBasic
		},
	];


	return(
		<>
			<MetaData 
				title='How it Works: The Customer Engagement Platform'
				description=' Discover how Loop helps you to connect, engage, and retain customers. Build a loyal community and drive growth.'
				name='description'
				type=''
			/>
			<LandingPageLayout
				JumbotronSection={<Jumbotron contents={content}/>}
				paddingTop='0px'
				isBusiness
			>
				{/* <Connections howItWorksLocalization={howItWorksLocalization} /> */}
				<HowItWorksSection isLoopBusiness mainHeading={howItWorksLocalization?.mainHeading} secondaryHeading={howItWorksLocalization?.secondaryHeading} SliderContent={steps} />
				<Campaigns howItWorksLocalization={howItWorksLocalization} />
				<Benefits howItWorksLocalization={howItWorksLocalization}/>
				<CTA ctaSubText={howItWorksLocalization?.ctaSubtext} ctaText={howItWorksLocalization?.ctaText} isCTA shouldIgnoreParentPadding isBusiness/>
			</LandingPageLayout>
		</>
	);
};